import { Button, Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import useTranslate from '../../../../../i18n/useTranslate'
import useSignREC1 from './useSignREC1'
import { ButtonClose, ButtonSign } from '../pageAction'
import Dialog from '../../../../../control/dialog/dialog'
import constSubmittedStatus from '../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../constants/submittedStep'

export type SignREC2ViewType = ReturnType<typeof useSignREC1>
const SignREC2View = (props: SignREC2ViewType) => {
    const {
        onRefDialog,
        configDialog,

        isViewMode,
        isNotShowSign,

        initialValues,
        certificateTopicList,
        initialUploadFileCer,
        initialUploadFileCerSign,
        projectData,
        handleDirtyChange,
        onClickBackToSearch,
        onSubmitForm,
    } = props
    const btn = (props: any) => {
        if (!isViewMode && !isNotShowSign) {
            return (
                <ButtonSign
                    onClickSave={() => {
                        props.form.change('saveType', 'SAVE')
                        props.handleSubmit()
                    }}
                />
            )
        } else {
            if (!isViewMode) {
                return <ButtonClose onClickClose={onClickBackToSearch} />
            }
        }
    }

    const translate = useTranslate()

    //มีการลงนามไปแล้ว
    const isSigning: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                uploadFile: initialUploadFileCer,
                signFile: initialUploadFileCerSign,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                return (
                    <>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    initialData={initialUploadFileCer}
                                    documentTitleList={certificateTopicList}
                                    title={translate.get('LABEL.CERTIFICATE')}
                                    isViewMode={true}
                                    disabledBtn={true}
                                />
                            </Grid>

                            {isSigning && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        name={'signFile'}
                                        initialData={initialUploadFileCerSign}
                                        documentTitleList={certificateTopicList}
                                        title={translate.get('LABEL.CERTIFICATE_SIGN')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {btn(props)}
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}
export type SignREC2Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const SignREC2 = (props: SignREC2Type) => {
    const sign = useSignREC1(props)
    return <SignREC2View {...sign} />
}

export default SignREC2
